// @/composables/useVuexCompat.js
import { computed } from 'vue';
import { getCurrentInstance } from 'vue';

export function useMapState(module, keys) {
    const store = getCurrentInstance().proxy.$store;
    return keys.reduce((mapped, key) => {
        mapped[key] = computed(() => store.state[module][key]);
        return mapped;
    }, {});
}

export function useMapGetters(getters) {
    const store = getCurrentInstance().proxy.$store;
    return Object.entries(getters).reduce((mapped, [localKey, storeGetter]) => {
        mapped[localKey] = computed(() => store.getters[storeGetter]);
        return mapped;
    }, {});
}

export function useMapActions(actions) {
    const store = getCurrentInstance().proxy.$store;
    return Object.entries(actions).reduce((mapped, [localKey, storeAction]) => {
        mapped[localKey] = (...args) => store.dispatch(storeAction, ...args);
        return mapped;
    }, {});
}
